import { Outlet } from "react-router-dom";
import "./index.css";

function App() {
  return <Outlet />;
}

export default App;
